import React from 'react'
import {
  List, Datagrid, TextField, EditButton, Create, SimpleForm, SelectInput, TextInput, Edit,
  ReferenceField, ReferenceInput, SelectField, Filter, NumberInput
} from 'admin-on-rest'
import LicensePlateField from '../components/licensePlateField'

const validateVehicles = (values) => {
  const errors = {}
  if (!values._organization) {
    errors._organization = ['A Empresa é obrigatória!']
  }
  if (!values.licensePlate) {
    errors.licensePlate = ['A Placa é obrigatória!']
  }
  if (!values.odometer) {
    errors.odometer = ['O Odômetro é obrigatório!']
  }
  return errors
}

const zero = <span> 0 </span>
const OdometerField = ({ record = {} }) =>
  <span>
    {isNaN(record.odometer) ? zero : record.odometer} km
  </span>
OdometerField.defaultProps = { label: 'Odômetro' }

const VehicleFilter = (props) => (
  <Filter {...props}>
    <ReferenceInput label='Empresa' source='_organization' reference='organization' perPage={400} allowEmpty>
      <SelectInput optionText='name' />
    </ReferenceInput>
  </Filter>
)

export const VehicleList = (props) => (
  <List {...props} title='Veículos' filters={<VehicleFilter />}>
    <Datagrid>
      <ReferenceField source='_organization' reference='organization' label='Empresa'>
        <TextField label='Empresa' source='name' />
      </ReferenceField>
      <TextField label='Placa' source='licensePlate' />
      <OdometerField label='Odômetro' source='odometer' />
      <SelectField source='status' choices={[
        {id: 'active', name: 'Ativo'},
        {id: 'inactive', name: 'Inativo'}
      ]}
      />
      <EditButton />
    </Datagrid>
  </List>
)

export const VehicleCreate = (props) => (
  <Create {...props} title='Criar Veículo'>
    <SimpleForm validate={validateVehicles}>
      <SelectInput source='status' label='Status' defaultValue='active' choices={[
        {id: 'active', name: 'Ativo'},
        {id: 'inactive', name: 'Inativo'}
      ]}
      />
      <ReferenceInput source='_organization' reference='organization' label='Empresa' perPage={100} allowEmpty>
        <SelectInput optionText='name' optionValue='_id' />
      </ReferenceInput>
      <LicensePlateField label='Placa' source='licensePlate' />
      <SelectInput label='Tipo de combustível' source='fuel' defaultValue='gas' choices={[
        {id: 'gas', name: 'Gasolina'},
        {id: 'ethanol', name: 'Etanol'},
        {id: 'flex', name: 'Flex'},
        {id: 'dieselS10', name: 'Diesel S10'},
        {id: 'dieselS500', name: 'Diesel S500'},
        {id: 'carrierNaturalGas', name: 'Gás Natural Veicular'}
      ]}
      />
      <NumberInput label='Capacidade do tanque (litros)' source='tank' />
      <NumberInput label='Média esperada (km/l)' source='efficiency' />
      <TextInput label='Odômetro' source='odometer' />
    </SimpleForm>
  </Create>
)

export const VehicleEdit = (props) => (
  <Edit {...props} title='Editar Veículo'>
    <SimpleForm validate={validateVehicles}>
      <SelectInput source='status' label='Status' defaultValue='active' choices={[
        {id: 'active', name: 'Ativo'},
        {id: 'inactive', name: 'Inativo'},
        {id: 'deleted', name: 'Excluído'}
      ]}
      />
      <ReferenceInput source='_organization' reference='organization' label='Empresa' perPage={100}>
        <SelectInput optionText='name' optionValue='_id' />
      </ReferenceInput>
      <LicensePlateField label='Placa' source='licensePlate' />
      <SelectInput label='Tipo de combustível' source='fuel' defaultValue='gas' choices={[
        {id: 'gas', name: 'Gasolina'},
        {id: 'ethanol', name: 'Etanol'},
        {id: 'flex', name: 'Flex'},
        {id: 'dieselS10', name: 'Diesel S10'},
        {id: 'dieselS500', name: 'Diesel S500'},
        {id: 'carrierNaturalGas', name: 'Gás Natural Veicular'}
      ]}
      />
      <NumberInput label='Capacidade do tanque (litros)' source='tank' />
      <NumberInput label='Média esperada (km/l)' source='efficiency' />
      <TextInput label='Odômetro' source='odometer' />
    </SimpleForm>
  </Edit>
)



// WEBPACK FOOTER //
// ./src/collections/vehicles.js